import React, { useState } from 'react';

const AddInvoiceModal = ({ open, onClose, onSubmit }) => {
  const [form, setForm] = useState({ client: '', amount: '', due: '' });

  const handleSubmit = (e) => {
    e.preventDefault();
    onSubmit(form);
    setForm({ client: '', amount: '', due: '' });
  };

  return (
    <div className={`modal-overlay ${open ? 'active' : ''}`} onClick={onClose} data-testid="add-invoice-modal">
      <div className="modal-box" onClick={e => e.stopPropagation()}>
        <div className="modal-icon primary">+</div>
        <div className="modal-title">Buat Invoice Baru</div>
        <div className="modal-sub" style={{ marginBottom: '20px' }}>Catat tagihan baru ke dalam sistem.</div>
        <form onSubmit={handleSubmit}>
          <div className="form-group">
            <label>Nama Client / Perusahaan</label>
            <input type="text" className="form-control" required placeholder="Contoh: GlobalPay Inc."
              value={form.client} onChange={e => setForm({ ...form, client: e.target.value })}
              data-testid="add-invoice-client" />
          </div>
          <div style={{ display: 'flex', gap: '16px' }}>
            <div className="form-group" style={{ flex: 1 }}>
              <label>Total Tagihan</label>
              <input type="text" className="form-control" required placeholder="Rp 10.000.000"
                value={form.amount} onChange={e => setForm({ ...form, amount: e.target.value })}
                data-testid="add-invoice-amount" />
            </div>
            <div className="form-group" style={{ flex: 1 }}>
              <label>Jatuh Tempo</label>
              <input type="date" className="form-control" required value={form.due}
                onChange={e => setForm({ ...form, due: e.target.value })}
                data-testid="add-invoice-due" />
            </div>
          </div>
          <div className="modal-actions">
            <button type="button" className="btn-modal btn-cancel" onClick={onClose} data-testid="add-invoice-cancel">Batal</button>
            <button type="submit" className="btn-modal btn-gold" data-testid="add-invoice-submit">Buat Tagihan</button>
          </div>
        </form>
      </div>
    </div>
  );
};

export default AddInvoiceModal;
